import { ActionTypes } from "../constants";

const getInactive = (applications, inactive) => {
    if (!applications?.length) { return {}; }

    const codes = applications.map(({applicationCode}) => applicationCode);
    const duplicates = codes.filter((code, index) => codes.indexOf(code) !== index);
    if (!duplicates?.length) { return {}; }

    return duplicates.reduce((acc, curr) => ({
        ...acc,
        [curr]: !!inactive[curr]?.length
            ? inactive[curr]
            : applications
                .filter(({applicationCode, uuid}) => uuid !== applications.find((app) => app.applicationCode === applicationCode).uuid)
                .map(({uuid}) => uuid)
    }), {});
};


const reduceApplications = (state = {applications: [], inactive: {}}, action) => {
    switch (action.type) {
        case ActionTypes.GET_APPLICATIONS:
            const applications = action.data || [];
            return {
                applications,
                inactive: getInactive(applications, state.inactive)
            };

        case ActionTypes.ACTIVATE_APPLICATION:
            return {
                ...state,
                inactive: {
                    ...state.inactive,
                    [action.payload.appCode]:
                        state.applications
                            .filter((app) => app.applicationCode === action.payload.appCode && app.uuid !== action.payload.uuid)
                            .map(({uuid}) => uuid)
                }
            };

        case ActionTypes.LOGOUT:
            return {...state, applications: []};

        default:
            return state;
    }
};

export const getApplication = (applications, appCode) => (
    applications.applications.find(
        (app) => app.applicationCode === appCode && !applications.inactive[appCode]?.includes(app.uuid)
    )
);
export const getCodes = ({applications}) => applications && applications.map(({applicationCode}) => applicationCode);
export const getRmsAppCode = ({applications}) => getCodes({applications}).find((code) => ['P-RMSD', 'P-RMSN'].includes(code));
export const isInactive = ({inactive}, appCode, uuid) => inactive[appCode]?.includes(uuid);

export default reduceApplications;
